module.exports = __webpack_public_path__ + "img/popularize04-4.a4ec7305.png";